export default __webpack_public_path__ + "static/media/AR-10.3d869541.jpg";